import { Component, OnInit } from "@angular/core";
import { EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Paginacao } from "src/app/util/paginacao";
import { PesquisaPropostaDto } from "src/app/model/dto/PesquisaPropostaDto";
import { PesquisaPropostaService } from "src/app/services/pesquisa-proposta.service";
import { ProgramaPacDto } from "src/app/model/dto/ProgramaPacDto";
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { Router } from "@angular/router";
import {AppRole} from 'src/app/common/constants/app-role.constant';
import { AgenteFinanceiro } from "src/app/model/AgenteFinanceiro";


@Component({
    selector: 'pesquisa-proposta',
    templateUrl: './pesquisa-proposta.component.html',
    styleUrls: ['./pesquisa-proposta.component.scss'],
    standalone: false
})
export class PesquisaPropostaComponent implements OnInit{

    dataUser: {cnpj:"", login:""};

    programaList: ProgramaPacDto[] = [];
    agenteFinanceiroList: AgenteFinanceiro[] = [];
    filtroPesquisa: PesquisaPropostaDto = new PesquisaPropostaDto();
    programaFiltrado: string;
    cnpjAgenteFinaceiroFiltrado: string;
    usuario: Usuario;
    abrirFiltro: boolean

    //Tabela
    labelTabela: string[] = ["Proposta", "Número PAC", "Comprador", "Agente Financeiro", "Entrada", "Aprovação", "Valor", "Fabricante", "Situação"];
    atributosOrdenacao: EntityOrderedRequestParameters;
    paginacao: Paginacao<PesquisaPropostaDto> = new Paginacao([10,20,30,50,100]);

    listaPesquisaProposta:PesquisaPropostaDto[] = [];

    constructor(
        private router: Router,
        private pesquisaPropostaService: PesquisaPropostaService,
        private alertsService: BnAlertsService,
        private usuarioService: BnUsuarioService
    ){}

    ngOnInit(){
        this.abrirFiltro = false
        this.buscarAgentesFinaceiros();
        this.usuarioService.usuario$.subscribe(
            (usuario: Usuario) => {
              this.usuario = usuario;
            });

        this.dataUser = JSON.parse(localStorage.getItem('login-data'));

        this.atualizarListaPrograma();
        this.atributosOrdenacao = {
            atributo: '',
            sentido: 'asc'
        }
    }

    pesquisar(){

        this.ajustaAtributosFiltro();

        this.pesquisaPropostaService.obterProposta(this.filtroPesquisa).subscribe(
            (propostas) => {
                this.listaPesquisaProposta = propostas;
                this.paginacao.atualizarItens(this.listaPesquisaProposta);

                if(this.listaPesquisaProposta.length == 0){
                    this.alertsService.alertaAviso("Sem resultados", "Não existem resultados para os filtros selecionados.");
                }
            },
            (error) =>{
                console.error(`Erro ao pesquisar proposta: ${error}`);
                this.alertsService.alertaErro("Erro ao realizar a pesquisa", "Entre em contato com a equipe de suporte do sistema.");
            }
        );
    }

    ajustaAtributosFiltro(){

        if(this.filtroPesquisa.aprovacao != null) this.filtroPesquisa.aprovacao = this.filtroPesquisa.aprovacao.trim();
        if(this.filtroPesquisa.comprador != null) this.filtroPesquisa.comprador = this.filtroPesquisa.comprador.trim().toUpperCase();
        if(this.filtroPesquisa.fabricante != null) this.filtroPesquisa.fabricante = this.filtroPesquisa.fabricante.trim().toUpperCase();


        this.filtroPesquisa.cnpjAgenteFinanceiro = null;
        if (this.cnpjAgenteFinaceiroFiltrado && this.cnpjAgenteFinaceiroFiltrado != ''){
            let filtroTemp = this.cnpjAgenteFinaceiroFiltrado.substring(this.cnpjAgenteFinaceiroFiltrado.length-19)
            this.filtroPesquisa.cnpjAgenteFinanceiro = filtroTemp.trim().replace(/\./gi, "").replace(/\//gi, "").replace(/\-/gi, "");
        }

        let programaPac = new ProgramaPacDto();

        if(this.programaFiltrado != 'undefined' && this.programaFiltrado != null){
            programaPac = this.programaList.find(f => f.id == +this.programaFiltrado);
        }

        this.filtroPesquisa.idPrograma = programaPac.idPrograma;
        this.filtroPesquisa.idSubPrograma = programaPac.idSubPrograma;
    }

    ordenar(ord: EntityOrderedRequestParameters){
        if (ord.sentido === "asc"){
			this.listaPesquisaProposta = this.paginacao.itens.sort((a, b) => (a[ord.atributo] < b[ord.atributo]) ? -1 : 1);
            this.paginacao.atualizarItens(this.listaPesquisaProposta);
		} else {
			this.listaPesquisaProposta = this.paginacao.itens.sort((a, b) => (a[ord.atributo] < b[ord.atributo]) ? 1 : -1);
			this.paginacao.atualizarItens(this.listaPesquisaProposta);
		}
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
		this.atributosOrdenacao = novaOrdenacao;
		this.ordenar(this.atributosOrdenacao);
	}

    atualizarListaPrograma(){
        this.pesquisaPropostaService.obterProgramasPac().subscribe(
            (programas) => {
                this.programaList = programas;
            },
            (error) => {
                console.error(`Erro ao obter os programas PAC: ${error}`);
                this.alertsService.alertaErro("Erro ao obter os programas PAC", "Entre em contato com a equipe de suporte do sistema.");
            }
        )
    }

    buscarAgentesFinaceiros(){
        this.pesquisaPropostaService.buscaAgentesFinaceiros().subscribe(
            (agentesFinanceiros) => {
                this.agenteFinanceiroList = agentesFinanceiros;
                this.agenteFinanceiroList.sort((a, b) => (a.nome > b.nome ? 1 : -1))
            },
            (error) => {
                console.error(`Erro ao obter os Agentes Financeiros: ${error}`);
                this.alertsService.alertaErro('Erro ao obter os Agentes Financeiros', "Entre em contato com a equipe de suporte do sistema.");
            }
        )
    }

    consultarProposta(proposta: PesquisaPropostaDto){
        this.router.navigate(["/detalhe-proposta/"+proposta.numeroPAC], {queryParams: {"id":proposta.id}});
    }

    get isUsuarioBndes(){
        if(!this.usuario?.possuiPermissao(AppRole.AGENTE_FINANCEIRO)){
            return true
        }
        return false;
    }

    get isAuditorBndes(){
        if(this.usuario?.possuiPermissao(AppRole.BNDES_AUDITOR)){
            return true
        }
        return false;
    }

    get isAgenteFinanceiro(){
        if(this.usuario?.possuiPermissao(AppRole.AGENTE_FINANCEIRO)){
            return true
        }
        return false;
    }

    buscarFabricantes(item: PesquisaPropostaDto){
        return item.fabricante.split('::')
    }

    getStyleSituacao(item: PesquisaPropostaDto){
        if(item.situacao === 'Aprovado'){
            return 'badge bg-success'
        } else if (item.situacao === 'Aprovado com Saldo Cancelado'){
            return 'badge bg-info'
        }else if(item.situacao === 'Cancelamento de Saldo Rejeitado pelo Sistemas Corporativos'){
            return 'badge bg-warning'
        }else {
            return 'badge bg-danger'
        }

    }

    filtro(){
        this.abrirFiltro = !this.abrirFiltro
    }

}
